export function twitterShare(text, page, id) {
    window.open(`http://twitter.com/share?text=${text}&url=https://anima-web.de/${page}/${id}`, '_blank', 'left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0');
}
